import { useParams } from 'react-router-dom';
import { useGroup } from './use-group';

export const useCurrentGroup = () => {
  const { groupId } = useParams<{ groupId: string }>();
  const currentGroupId = parseInt(groupId ?? '-1');

  return useGroup(currentGroupId);
};
